export default "__VITE_ASSET__BLv1MumY__"